import { faMedal } from "@jewlr/pro-light-svg-icons/faMedal"
import { faRotateLeft } from "@jewlr/pro-light-svg-icons/faRotateLeft"
import { faTruckBolt } from "@jewlr/pro-light-svg-icons/faTruckBolt"
import PropTypes from "prop-types"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { jewlr_t, IS_GE_CHECKOUT } from "helpers/application"

const ValuePropItem = ({ icon, title, description }) => (
  <div className="flex items-center gap-12">
    <div className="shrink-0">
      <FontAwesomeIcon
        className="text-32 tablet:text-36 text-black"
        icon={icon}
      />
    </div>
    <div className="flex-1">
      <h3 className="text-14 tablet:text-16 mb-4 font-semibold uppercase leading-tight">
        {title}
      </h3>
      <p className="text-12 tablet:text-13">{description}</p>
    </div>
  </div>
)

ValuePropItem.propTypes = {
  description: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}

const PDPValueProps = () => {
  const is_ge_checkout = IS_GE_CHECKOUT()
  const returnDays = is_ge_checkout ? "30" : "99"

  const valueProps = [
    {
      description: `Buy with confidence! We offer a no-hassle ${returnDays}-day return policy.`,
      icon: faRotateLeft,
      key: "returns",
      title: `${returnDays}-Day Returns`,
    },
    {
      description: `We offer fast, free standard ${jewlr_t("terms.shipping")} directly to your doorstep.`,
      icon: faTruckBolt,
      key: "shipping",
      title: `Free ${jewlr_t("terms.Shipping")}`,
    },
    {
      description: `Our ${jewlr_t("terms.jewelry")} includes a free one-year manufacturer's warranty.`,
      icon: faMedal,
      key: "warranty",
      title: "One-Year Warranty",
    },
  ]

  return (
    <div className="bg-grey-4 tablet:p-16 mb-10 p-12">
      <div className="tablet:gap-16 flex flex-col gap-12">
        {valueProps.map((prop) => (
          <ValuePropItem
            description={prop.description}
            icon={prop.icon}
            key={prop.key}
            title={prop.title}
          />
        ))}
      </div>
    </div>
  )
}

export default PDPValueProps
